
<!-- In dev and staging environments, the 'local-network-access' attribute is required to solve Chrome CORS errors that block calls to the BFF. In production, this attribute is not needed. -->
<iframe
    *ngIf="!isProduction"
    #drawingToolIframe
    id="drawingToolIframeID"
    class="drawingToolIframe"
    allow="local-network-access"
    (load)="uploadDrawingToolIframe()"
    [src]="drawingToolUrl | safeUrl">
</iframe>
<iframe
    *ngIf="isProduction"
    #drawingToolIframe
    id="drawingToolIframeID"
    class="drawingToolIframe"
    (load)="uploadDrawingToolIframe()"
    [src]="drawingToolUrl | safeUrl">
</iframe>
